<div class="bots-list">
  <h2>Pre-configured agents</h2>
  <div class="bots-list__bots">
    @for (bot of bots; track bot) {
      <div (click)="selectBot(bot._id)" class="bots-list__bot-item" [ngClass]="{selected: bot.selected}">{{ bot.name }}</div>
    }
  </div>
  <button (click)="goToBots()" mat-raised-button color="secondary">View all</button>
</div>
